export abstract class AuthService {
  abstract logout(): void;
  abstract getAccessToken(): string;
}
